export const environment = {
  production: true,
  hmr: false,
  storeDomain: 'https://kado-design-v3.myshopify.com/',
  storefrontToken: '9f16bf23cb368a5fe1cf1f327076d6af',
  storeName: 'Kado Design',
  storeOrganisation: 'Kado Design',
  pixelCode: '180741874396951',
};
